import { EntityKeyConfig } from '../../../types/entities';

/**
 * Entity Keys for MATERIALS
 * 
 * Defines the key structure used throughout the application
 * for this entity type.
 */
export const keys: EntityKeyConfig = {
  single: 'material',
  plural: 'materials',
  state: 'materials',
  collection: 'materialsAttributes'
};
